// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__3LdU_","balanceDisclaimer":"posDashboard_balanceDisclaimer__1Hubd"};